module.exports = __webpack_public_path__ + "img/traffic-light-slow.af247bc8.svg";